import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/categories';
import { comics } from '@/mocks/comics';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.href
      ? { '@id': `https://hanmancomic.com${item.href}`, name: item.label }
      : { name: item.label },
  }));

  return (
    <>
      <nav aria-label="面包屑导航" className="py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium whitespace-nowrap">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: schemaItems,
          }),
        }}
      />
    </>
  );
}

export function getCategoryBreadcrumb(category: string) {
  return [
    { label: '首页', href: '/' },
    { label: categoryMap[category] || category, href: `/category/${category}` },
  ];
}

export function getArticleBreadcrumb(slug: string, title: string, category: string) {
  return [
    { label: '首页', href: '/' },
    { label: categoryMap[category] || category, href: `/category/${category}` },
    { label: title },
  ];
}